var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "timePathA",
    d: "M.722 7.29A.716.716 0 0 0 0 8c0 .393.322.71.721.71A.717.717 0 0 0 1.443 8a.716.716 0 0 0-.721-.71zm3.073 6.667c-.2.34-.08.775.264.971.345.197.787.08.986-.26.2-.34.08-.775-.264-.971a.728.728 0 0 0-.986.26zM2.073 3.74a.727.727 0 0 0-.985.26c-.2.34-.082.775.264.971.345.196.786.08.986-.26a.705.705 0 0 0-.265-.97zm-.721 7.289a.705.705 0 0 0-.264.971c.199.34.64.457.985.26a.706.706 0 0 0 .265-.971.728.728 0 0 0-.986-.26zm3.693-9.697c.199.34.08.775-.264.971a.728.728 0 0 1-.986-.26.705.705 0 0 1 .264-.971.727.727 0 0 1 .986.26zM15.278 7.29c.4 0 .722.318.722.71a.716.716 0 0 1-.721.712.717.717 0 0 1-.722-.712c0-.392.323-.71.721-.71zm-3.073 6.668c.2.34.08.775-.264.971a.728.728 0 0 1-.986-.26.706.706 0 0 1 .264-.971.728.728 0 0 1 .986.26zM13.927 3.74a.727.727 0 0 1 .985.26c.2.34.082.775-.264.971a.728.728 0 0 1-.986-.26.705.705 0 0 1 .265-.97zm.721 7.289a.705.705 0 0 1 .264.971.728.728 0 0 1-.985.26.706.706 0 0 1-.265-.971c.2-.34.641-.457.986-.26zm-3.693-9.697c.2-.34.64-.456.986-.26.345.196.463.63.264.971-.2.34-.64.457-.986.26a.705.705 0 0 1-.264-.97zM8.118 14.578c.399 0 .722.318.722.71a.716.716 0 0 1-.722.712.716.716 0 0 1-.721-.711c0-.393.323-.711.721-.711zM8.12 0c.398 0 .721.318.721.711a.716.716 0 0 1-.721.711.716.716 0 0 1-.722-.71C7.398.317 7.72 0 8.12 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "timePathB",
    cx: 12,
    cy: 12,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "timePathD",
    d: "M1 0h7a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H2a2 2 0 0 1-2-2V1a1 1 0 0 1 1-1z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#98D468",
    transform: "translate(4 4)",
    xlinkHref: "#timePathA"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#timePathB"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#98D468",
    transform: "translate(11 4)",
    xlinkHref: "#timePathD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/timeIcon.6acaf76e.svg";
export { ForwardRef as ReactComponent };